import React from "react";
import { Card, Col, Row, Badge } from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import {
  getFullName,
  getCurrencyCode,
} from "../../../../../helpers/CommonHelper";
import ReactFancyBox from "react-fancybox";
import { Link, useNavigate } from "react-router-dom";
import { FaUserAlt } from "react-icons/fa";
const Details = ({ item }) => {
  const navigate = useNavigate();
  const getCustomerStats = () => {
    let items = [];

    if (item?.subscriptionsCount) {
      items.push({
        text: "No. of Subscriptions",
        value: item?.subscriptionsCount,
        type: "number",
      });
    }

    if (item?.ordersCount) {
      items.push({
        text: "No. of Orders",
        value: item?.ordersCount,
        type: "number",
      });
    }

    if (item?.nationality) {
      items.push({
        text: "Nationality",
        value: item?.nationality,
        type: "text",
      });
    }

    if (item?.initiallyAccountCreatedFor) {
      items.push({
        text: "Account Created For",
        value: item?.initiallyAccountCreatedFor,
        type: "text",
      });
    }

    // if (item?.disclaimerAccepted) {
    //   items.push({
    //     text: "Disclaimer Accepted",
    //     value: item?.disclaimerAccepted,
    //     trueValue: "Yes",
    //     falseValue: "No",
    //     type: "boolean",
    //   });
    // }

    // if (item?.emailVerified) {
    //   items.push({
    //     text: "Email Verified",
    //     value: item?.emailVerified,
    //     trueValue: "Yes",
    //     falseValue: "No",
    //     type: "boolean",
    //   });
    // }

    if (item?.profileCompleted) {
      items.push({
        text: "Profile Completed",
        value: item?.profileCompleted,
        trueValue: "Yes",
        falseValue: "No",
        type: "boolean",
      });
    }

    if (item?.kidsCount) {
      items.push({
        text: "No. of Kids",
        value: item?.kidsCount,
        type: "number",
      });
    }

    return items;
  };
  return (
    <Row>
      <Col>
        <Card className="item mb-2 borderCream">
          <Card.Header className="ps-1 pe-2 py-0 ">
            <div className="card-tools endColumn mb-1 pt-1">
              <div>
                {" "}
                {item.status && (
                  <span
                    className={`badge fw-semibold rounded-pill shadow-sm me-1 px-2 ${
                      item.status === "1"
                        ? "bg-custom-4"
                        : item.status === "0"
                          ? "bg-custom-6"
                          : ""
                    }`}
                  >
                    {item.status === "1" ? "Active" : "Inactive"}
                  </span>
                )}
                {item?.createdAt && (
                  <span className="badge badge-light me-1 text-dark">
                    Profile Created On :{" "}
                    <span className="text-secondary">
                      <ModuleDisplayDate value={item?.createdAt} />{" "}
                    </span>
                  </span>
                )}
              </div>
            </div>
            <Card.Title className="d-flex m-0 p-0">
              <div className="d-flex ImageSectionSpacing">
                <div className="ms-1 mt-1 me-2 fossilImage">
                  {item.image ? (
                    <ReactFancyBox
                      thumbnail={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                      image={`${process.env.REACT_APP_BACKEND_URL}public/${item.image}`}
                      caption={`${item.firstName} ${item.lastName}`}
                    />
                  ) : (
                    <FaUserAlt className="text-secondary fs-2 ms-1" />
                  )}
                </div>

                <div className="d-flex flex-column align-items-start justify-content-center ms-1">
                  <span className="m-0 text-bold text-red">
                    {" "}
                    <span className="">
                      {item.firstName} {item.lastName}
                    </span>
                  </span>
                  <span className="">
                    <span className="text-custom-4 mt-1 small  text-bold">
                      <ModuleDisplayEmail value={item.email} /> ({" "}
                      <ModuleDisplayPhone value={item.mobile} />)
                    </span>
                  </span>
                </div>
              </div>
            </Card.Title>
          </Card.Header>
          <Card.Body className="p-1">
            <Row>
              <Col className="mt-0 mb-0 ">
                {/* <StatsListing heading="Cart" clickable items={getCart()} /> */}
                <StatsListing items={getCustomerStats()} />
              </Col>
            </Row>
            <Row>
              <Col xl={8} className="mt-0 mb-0 ">
                {item.kids && item.kids.length > 0 && (
                  <div
                    className="info-box borderCream rounded shadow-sm mb-1 p-0"
                    style={{ backgroundColor: "#fffaf5ff" }}
                  >
                    <div className="info-box-content p-0">
                      {/* Header */}
                      <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                        <i className="fas fa-child me-2"></i> Kids Details
                      </h6>

                      {/* Kids Grid */}
                      <div className="px-3 py-2">
                        <Row className="fw-bold text-muted small mb-2 border-bottom pb-1">
                          <Col>Name</Col>
                          <Col>Age</Col>
                          <Col>Gender</Col>
                          <Col>School</Col>
                        </Row>

                        {item.kids.map((kid, index) => (
                          <Row
                            key={index}
                            className="align-items-center small border-bottom py-1 mb-1"
                          >
                            <Col className="fw-semibold">
                              <i className="fas fa-user me-2 text-custom-2"></i>
                              {kid.firstName} {kid.lastName}
                            </Col>

                            <Col>{kid.age} yrs</Col>

                            <Col>
                              <Badge
                                bg={kid.gender === "Girl" ? "pink" : "primary"}
                                className="text-uppercase"
                              >
                                {kid.gender}
                              </Badge>
                            </Col>

                            <Col>
                              {kid.schoolName ? (
                                <>
                                  <i className="fas fa-school me-1 text-secondary"></i>
                                  {kid.schoolName}
                                </>
                              ) : (
                                "-"
                              )}
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </Col>
            </Row>

            {/* Kids Info - Table Style */}

            {/* Orders Info */}
            {item.currentSubscriptions &&
              item.currentSubscriptions.length > 0 && (
                <div
                  className="info-box borderCream rounded shadow-sm p-0 mb-0"
                  style={{ backgroundColor: "#fffaf5ff" }}
                >
                  <div className="info-box-content p-0">
                    {/* Header */}
                    <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                      <i className="fas fa-list-alt me-2"></i> Subscription(s)
                    </h6>

                    {/* Subscriptions Grid */}
                    <div className="p-1">
                      <Row>
                        {item.currentSubscriptions.map((sub, index) => (
                          <Col
                            key={index}
                            xl={3}
                            lg={4}
                            md={6}
                            sm={12}
                            className="mb-1"
                          >
                            <div
                              title="Click to view subscription details"
                              className="border rounded p-2 shadow-sm h-100 cursor-pointer"
                              style={{
                                backgroundColor: "#fffdf8",
                                borderColor: "#f1e2d1",
                              }}
                              onClick={() =>
                                navigate(`/subscriptions/${sub._id}`)
                              }
                            >
                              {/* Plan Title + Status */}
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="fw-bold">
                                  {sub?.plan?.title || "-"}
                                </span>
                                <Badge
                                  pill
                                  bg={
                                    sub.status === "Active"
                                      ? "success"
                                      : "secondary"
                                  }
                                >
                                  {sub.status}
                                </Badge>
                              </div>

                              <hr
                                className="my-1"
                                style={{
                                  height: "0.5px",
                                  backgroundColor: "#ccc",
                                }}
                              />

                              {/* Charged Days */}
                              {sub.subscribedMeals &&
                                sub.subscribedMeals.length > 0 && (
                                  <>
                                    <div className="d-flex justify-content-between small mb-1">
                                      <span>Charged Days:</span>
                                      <span className="fw-semibold">
                                        {sub.subscribedMeals.reduce(
                                          (sum, meal) =>
                                            sum + (meal.chargedDays || 0),
                                          0,
                                        )}{" "}
                                        days
                                      </span>
                                    </div>
                                    <hr
                                      className="my-1"
                                      style={{
                                        height: "0.5px",
                                        backgroundColor: "#ccc",
                                      }}
                                    />
                                  </>
                                )}

                              {/* Plan Type */}
                              <div className="d-flex justify-content-between small mb-1">
                                <span>Plan Type:</span>
                                <span className="fw-semibold">
                                  {sub.vegOrNonVeg || "-"}
                                </span>
                              </div>

                              <hr
                                className="my-1"
                                style={{
                                  height: "0.5px",
                                  backgroundColor: "#ccc",
                                }}
                              />

                              {/* Auto Renew */}
                              <div className="d-flex justify-content-between small mb-1">
                                <span>Auto Renew:</span>
                                <Badge
                                  pill
                                  style={{ lineHeight: "13px" }}
                                  bg={
                                    sub.autoRenew === "1"
                                      ? "success"
                                      : "secondary"
                                  }
                                >
                                  {sub.autoRenew === "1" ? "Yes" : "No"}
                                </Badge>
                              </div>

                              <hr
                                className="my-1"
                                style={{
                                  height: "0.5px",
                                  backgroundColor: "#ccc",
                                }}
                              />

                              {/* Total Amount */}
                              <div className="d-flex justify-content-between mb-1">
                                <span className="small">Total:</span>
                                <span className="fw-bold text-custom-1">
                                  {sub.totalAmount?.$numberDecimal || "0"}{" "}
                                  {getCurrencyCode()}
                                </span>
                              </div>

                              {/* Subscribed Meals */}
                              {sub.subscribedMeals &&
                                sub.subscribedMeals.length > 0 && (
                                  <>
                                    <div className="mt-1">
                                      <div className="d-flex flex-wrap gap-1">
                                        {sub.subscribedMeals.map(
                                          (meal, idx) => (
                                            <Badge
                                              key={idx}
                                              className="border border-cream badge-custom-7 text-white"
                                            >
                                              {meal.meal?.title || "-"}
                                            </Badge>
                                          ),
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                </div>
              )}
            {item.currentOrders && item.currentOrders.length > 0 && (
              <div
                className="info-box borderCream rounded shadow-sm p-0 mb-0"
                style={{ backgroundColor: "#fffaf5ff" }}
              >
                <div className="info-box-content p-0">
                  {/* Header */}
                  <h6 className="info-box-number m-0 text-red mb-2 bg-custom-6 py-1 px-3 fw-bold rounded-top">
                    <i className="fas fa-list-alt me-2"></i> Order(s)
                  </h6>

                  {/* Subscriptions Grid */}
                  <div className="p-1">
                    <Row>
                      {item.currentOrders.map((sub, index) => (
                        <Col
                          key={index}
                          xl={3}
                          lg={4}
                          md={6}
                          sm={12}
                          className="mb-1"
                        >
                          <div
                            title="Click to view subscription details"
                            className="border rounded p-2 shadow-sm h-100 cursor-pointer"
                            style={{
                              backgroundColor: "#fffdf8",
                              borderColor: "#f1e2d1",
                            }}
                            onClick={() => navigate(`/orders/${sub._id}`)}
                          >
                            {/* Plan Title + Status */}
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <span className="fw-bold">
                                <i className="fas fa-box me-2 text-custom-4"></i>
                                {sub?.orderId || "-"}
                              </span>
                              <Badge
                                pill
                                bg={
                                  sub.orderStatus === "1"
                                    ? "success"
                                    : sub.orderStatus === "2"
                                      ? "danger"
                                      : "warning"
                                }
                              >
                                {sub.orderStatus === "1"
                                  ? "Delivered"
                                  : sub.orderStatus === "2"
                                    ? "Cancelled"
                                    : "Pending"}
                              </Badge>
                            </div>

                            <hr
                              className="my-1"
                              style={{
                                height: "0.5px",
                                backgroundColor: "#ccc",
                              }}
                            />

                            {/* Charged Days */}

                            {/* Plan Type */}
                            <div className="d-flex justify-content-between small mb-1">
                              <span>Ordered Items:</span>
                              <span className="fw-semibold">
                                {sub.orderedItemsCount || "-"}
                              </span>
                            </div>

                            <hr
                              className="my-1"
                              style={{
                                height: "0.5px",
                                backgroundColor: "#ccc",
                              }}
                            />

                            {/* Total Amount */}
                            <div className="d-flex justify-content-between mb-1">
                              <span className="small">Total:</span>
                              <span className="fw-bold text-custom-1">
                                {sub.totalAmount || "0"} {getCurrencyCode()}
                              </span>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Details;
